import React from 'react';
import { Container, Header, Grid, List, Segment, Image, Sidebar } from 'semantic-ui-react';
import { createMedia } from '@artsy/fresnel';
import { InView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import supinie_solutions from '../supinie_solutions.png';
import 'semantic-ui-css/semantic.min.css';
import { Dashboard } from './Dashboard';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

const SmallHeading = ({ mobile }) => (
  <Container text>
    <Header
      as="h1"
      content="Data Protection"
      style={{
        color: '#f46f22',
        fontSize: mobile ? '2em' : '3em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '2em',
      }}
    />
  </Container>
);

SmallHeading.propTypes = {
  mobile: PropTypes.bool,
};

class DesktopContainer extends React.Component {
  state = {};

  toggleFixedMenu = (inView) => this.setState({ fixed: !inView });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;
    return (
      <Media greaterThan="mobile">
        <InView onChange={this.toggleFixedMenu}>
          <Segment
            inverted
            textAlign="center"
            style={{ minHeight: 200, padding: '0em' }}
            vertical
          >
            <SmallHeading />
          </Segment>
        </InView>
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends React.Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;
    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <Sidebar.Pushable>
          <Sidebar.Pusher dimmed={sidebarOpened}>
            <Segment
              inverted
              textAlign='center'
              style={{ minHeight: 150, padding: '0em' }}
              vertical
            >
              <SmallHeading mobile />
            </Segment>

            {children}
          </Sidebar.Pusher>
        </Sidebar.Pushable>

      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const DataPolicy = () => (
  <ResponsiveContainer>
    <Segment style={{ padding: '8em 0em' }} vertical>
      <Grid container stackable verticalAlign='middle'>
        <Grid.Row>
          <Grid.Column width = {14}>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Supinie Solutions LTD is committed to providing superior service to everyone we work with. We know that our users are dedicated to their success, and we are equally committed to ensuring that each interaction someone has with our content and service delivery is optimized for maximum potential. To enable us to do this, Supinie Solutions LTD needs to gather and use certain information about individuals and companies.
            </p>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Individuals and businesses from whom we gather information include clients and customers, affiliates, business contacts, employees, and other people the organization has a relationship with or may need to contact.
            </p>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                This policy describes how personal data is collected, handled, and stored to meet the company’s data protection standards — and to comply with the law.
            </p>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                This data protection policy ensures that Supinie Solutions LTD: Complies with data protection law and follows industry best practices, protects the rights of staff, customers, affiliates, and partners, is open about how it stores and processes individuals’ data, protects itself from the risks of a data breach.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                EU General Data Protection Regulation (GDPR)
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                The GDPR (General Data Protection Regulation) protection law describes how organizations that conduct business with individuals or entities located in EU (European Union) nations — including Supinie Solutions LTD — must collect, handle, and store personal information. These rules apply regardless of whether data is stored electronically, on paper, or in any other manner. To comply with the law, personal information must be collected and used fairly, stored safely, and not disclosed unlawfully. The EU GDPR is underpinned by eight core principles. These state that personal data must: Be processed fairly and lawfully, be obtained only for specific, lawful purposes, be adequate, relevant, and not excessive, be accurate and kept up to date, not be held for any longer than necessary, be processed in accordance with the rights of data subjects, be protected in appropriate ways, not be transferred outside the European Economic Area (EEA), unless that country or territory also ensures an adequate level of protection.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Policy Statement
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Every day, our business will receive, use, and store personal information about our customers, affiliates, partners, and colleagues. It is important that this information is handled lawfully and appropriately, in line with the requirements of the Data Protection Act 2018 and the General Data Protection Regulation (collectively referred to as the ‘Data Protection Requirements’). We take our data protection duties seriously because we respect the trust placed in us to use personal information appropriately and responsibly.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                About This Policy
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                This policy, along with any other documents referred to within it, sets out the basis on which we will process any personal data that we collect or process. This policy does not form part of any employee’s contract of employment and may be amended at any time. The company as a whole is responsible for ensuring compliance with the Data Protection Requirements and with this policy. Any questions about the operation of this policy or any concerns that the policy has not been followed should be referred to the Data Protection Officer in the first instance.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                What is Personal Data?
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Personal data is defined as data, whether stored electronically or paper-based, relating to a living individual who can be identified directly or indirectly from that data or from that data and other information in our possession. Processing is any activity that involves the use of personal data. It includes obtaining, recording, or holding the data, organizing, amending, retrieving, using, disclosing, erasing, or destroying it. Processing also includes transferring personal data to third parties under privacy control conditions. Sensitive personal data includes contact info, address, session activity on the platform, IP location, etc. Sensitive personal data can only be processed under strict conditions and used for the express purpose for which it was collected.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Data Protection Principles
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Anyone processing personal data must ensure that data is: Processed fairly, lawfully, and in a transparent manner. Collected for specified, explicit, and legitimate purposes, and any further processing is completed for a compatible purpose. Adequate, relevant, and limited to what is necessary for the intended purposes. Accurate and, where necessary, kept up to date. Kept in a form that permits identification for no longer than necessary for the intended purposes. Processed in line with the individual’s rights and in a manner that ensures appropriate security of the personal data, including protection against unauthorized or unlawful processing and against accidental loss, destruction, or damage, using appropriate technical or organizational measures. Not transferred to people or organizations situated in countries without adequate protection and without first advising the individual.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Fair and Lawful Processing
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                The Data Protection Requirements are not intended to prevent the processing of personal data but to ensure that it is done fairly and without adversely affecting the rights of the individual. In accordance with the General Data Protection Regulation (GDPR), we will only process personal data where it is required for a lawful purpose. The lawful purposes include (amongst others): whether the individual has given their consent, the processing is necessary for performing a contract with the individual, for compliance with a legal obligation, or for the legitimate interest of the business. When sensitive personal data is being processed, additional conditions must be met.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Collection of Information
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We recieve and store only information that you provide (email address), and business information you have given your explicit permission for us to collect via official Amazon APIs.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Use of Information
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We use the information we collect to provide, analyze, administer, enhance, and personalize our services, to process your registration, and your communication on these and other topics. Our primary aim is always to enhance the user experience. We do so in several ways using the data we collect, but a few examples are to provide our services, required action item completions, and login details. This helps us identify any difficulties you may be facing within the platform, which we can then address to minimize the effort on your end.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Notifying Individuals
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                If we collect personal data directly from an individual, we will inform them about: The purpose or purposes for which we intend to process that personal data, as well as the legal basis for the processing. Where we rely upon the legitimate interests of the business to process personal data, the legitimate interests pursued. The types of third parties, if any, with which we will share or disclose that personal data. The fact that the business intends to transfer personal data to a non-EEA country or international organization and the appropriate and suitable safeguards in place. How individuals can limit our use and disclosure of their personal data. Information about the period that their information will be stored or the criteria used to determine that period. Their right to request from us as the controller access to and rectification or erasure of personal data or restriction of processing. Their right to object to processing and their right to data portability. Their right to withdraw their consent at any time (if consent was given) without affecting the lawfulness of the processing before the consent was withdrawn. The right to lodge a complaint with the Information Commissioner’s Office. Other sources where personal data regarding the individual originated from and whether it came from publicly accessible sources. Whether the provision of the personal data is a statutory or contractual requirement, or a requirement necessary to enter into a contract, as well as whether the individual is obliged to provide the personal data and any consequences of failure to provide the data. The existence of automated decision-making, including profiling, and meaningful information about the logic involved, as well as the significance and the envisaged consequences of such processing for the individual. If we receive personal data about an individual from other sources, we will provide them with this information as soon as possible (in addition to telling them about the categories of personal data concerned) but at the latest within one (1) month. We will also inform data subjects whose personal data we process that we are the data controller with regard to that data and our contact detail regarding the data protection act is privacy@supinie.com, and who the Data Protection Compliance Manager/Data Protection Officer is.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Adequate, Relevant and Non-Excessive Processing
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We will only collect personal data to the extent that it is required for the specific purpose notified to the data subject.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Accurate Data
            </Header>

            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We will ensure that personal data we hold is accurate and kept up to date. We will check the accuracy of any personal data at the point of collection and at regular intervals afterwards. We will take all reasonable steps to destroy or amend inaccurate or out-of-date data.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Timely Processing
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We will not keep personal data longer than necessary for the purpose or purposes for which it was collected. We will take all reasonable steps to destroy or erase from our systems, all data which is no longer required.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Processing in line with Data Subject’s Rights
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We will process all personal data in line with data subjects’ rights, in particular their right to:

                    Confirmation as to whether or not personal data concerning the individual is being processed.
                    Request access to any data held about them by a data controller.
                    Request rectification, erasure or restriction on processing of their personal data.
                    Lodge a complaint with a supervisory authority.
                    Data portability.
                    Object to processing including for direct marketing.
                    Not be subject to automated decision making including profiling in certain circumstances.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Data Security
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We will take appropriate security measures against unlawful or unauthorized processing of personal data and against the accidental or unlawful destruction, damage, loss, alteration, or unauthorized disclosure of or access to personal data transmitted, stored, or otherwise processed.
                We will put in place procedures and technologies to maintain the security of all personal data from the point of the determination of the means for processing and point of data collection to the point of destruction. Personal data will only be transferred to a data processor if he or she agrees to comply with those procedures and policies, or if he or she puts in place adequate measures himself/herself.
                We will maintain data security by protecting the confidentiality, integrity, and availability of the personal data, defined as follows:
                    Confidentiality: Only people who are authorized to use the data can access it.
                    Integrity: Personal data should be accurate and suitable for the purpose for which it is processed.
                    Availability: Authorized users should be able to access the data if they need it for authorized purposes. Personal data should therefore be stored on the IntoProfits.com central computer system & databases instead of individual PCs.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Our Security Procedures:
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                Entry controls: Any stranger seen in entry-controlled areas will be reported.
                Securing lockable desks and cupboards all the time. Desks and cupboards should be kept locked if they hold confidential information of any kind. (Personal information is always considered confidential.)
                Data minimization will be practiced.
                Pseudonymisation and encryption of data will be the primary state of storing the data.
                Methods of disposal: Paper documents would be shredded. Digital storage devices would be physically destroyed when they are no longer required. Electronic data would be deleted once it’s intended purpose is fulfilled.
                Equipment: Staff has to ensure that individual monitors do not show confidential information to passers-by and that they log off from their PC when it is left unattended.
            Subject to the requirements above, personal data we hold may also be processed by staff operating outside the EEA who work for us or for one of our suppliers. Those staff may be engaged in, among other things, the fulfilment of contracts with the data subject, the processing of payment details and the provision of support services.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Disclosure and Sharing of Personal Data
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We do not share or disclose any personal information.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
Subject Access Requests
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                To these ends, the company has a privacy statement setting out how data relating to individuals is used by the company.
                Individuals must make a formal request for information we hold about them. Employees who receive a request should forward it to the data department immediately.
                When receiving telephone enquiries, we will only disclose personal data we hold on our systems if the following conditions are met:
                    We will check the caller’s identity to make sure that information is only given to a person who is entitled to it.
                    We will suggest that the caller put their request in writing if we are not sure about the caller’s identity and where their identity cannot be checked.
                    Where a request is made electronically, data will be provided electronically when possible.
                Our support team will refer a request to the data processing department or the Data Protection Compliance Manager for assistance in difficult situations.
            </p>
            <Header as='h3' style={{ fontSize: '2em', color: '#f46f22' }}>
                Changes to this Policy
            </Header>
            <p style={{ fontSize: '1.33em', fontWeight: 'Normal', color: '#b9b5b2' }}>
                We may modify this Privacy Statement at any time, but we will provide prominent advance notice of any material changes to this Statement, such as posting a notice through the Services, on our websites, or sending you an email, to provide you the opportunity to review the changes and choose whether to continue using the Services.
            </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    </Segment>


    <Segment inverted vertical style={{ padding: '5em 0em' }}>
      <Container>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <Header inverted as='h4' content='About' />
              <List link inverted>
                <List.Item as='a'>Sitemap</List.Item>
                <List.Item><a href="mailto:inquiries@supinie.mozmail.com?body=Supinie Solutions inquiry">Contact Us</a></List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted as='h4' content='Services' />
              <List link inverted>
                <List.Item><a href="/our_products">Our Products</a></List.Item>
                <List.Item><a href="/security">Security</a></List.Item>
                <List.Item><a href="/data_policy">Data Policy</a></List.Item>
                <List.Item><a href="/privacy">Privacy</a></List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={7}>
              <Header as='h4' inverted style={{ color: '#b9b5b2' }}>
                Supinie Solutions
              </Header>
              <p style={{ fontSize: '1em', color: '#b9b5b2' }}>
                Supinie Solutions LTD, 2023
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  </ResponsiveContainer>
);

export default DataPolicy;
